import { GetStaticPaths, GetStaticProps } from 'next'

import initApollo, { API } from '../../api'

import { PAGES, POST } from './queries'

export const getStaticPaths: GetStaticPaths = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.PostPages>({
    query: PAGES,
  })

  const posts = data.libraryPosts?.nodes

  const paths = posts?.map((post) => `/posts/${post.slug}`) ?? []

  return { paths, fallback: false }
}

export type Props = NonNullable<API.Post['libraryPost']>

type Params = {
  slug: string
}

export const getStaticProps: GetStaticProps<Props, Params> = async ({ params, preview }) => {
  const client = initApollo({})

  const { data } = await client.query<API.Post, API.PostVariables>({
    query: POST,
    variables: {
      slug: params!.slug,
      status: preview ? API.LibraryPostStatus.DRAFT : undefined,
    },
  })

  if (!data.libraryPost)
    return {
      notFound: true,
    }

  return {
    props: data.libraryPost,
  }
}
